export default __webpack_public_path__ + "transfix-maps/icons/D1-newWave.eb89758d4d9a73b8b2a518197c9b9f60.png";